import React from 'react';
import { Alert } from 'react-bootstrap';
import { IntelligenceProductStatus } from '../../../api/ai';

interface IntelligencePendingVesBannerProps {
  items: NonNullable<IntelligenceProductStatus['pendingVes']>;
}

const IntelligencePendingVesBanner: React.FC<
  IntelligencePendingVesBannerProps
> = ({ items }) => {
  if (!items.length) return null;
  return (
    <Alert variant="warning" className="mb-3">
      <Alert.Heading className="h6 mb-2">
        Pago en Bolívares en revisión
      </Alert.Heading>
      <p className="mb-2 small">
        Estas compras esperan aprobación. Los créditos o la capacidad no cambian
        hasta que se apruebe el comprobante.
      </p>
      <ul className="mb-0 ps-3">
        {items.map(item => (
          <li key={item.requestId || item.itemDescription}>
            <strong>{item.productLabel}</strong>
            {' · '}
            {item.itemDescription}
            {item.amountUSD > 0 ? ` · $${item.amountUSD.toFixed(2)} USD` : ''}
            {item.amountVES > 0
              ? ` (${Math.round(item.amountVES).toLocaleString()} Bs)`
              : ''}
          </li>
        ))}
      </ul>
    </Alert>
  );
};

export default IntelligencePendingVesBanner;
